import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
import loadConfig from "@Web3WalletConfig/config";
export default {
  name: "gift",
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", 'setting'])
  },
  data() {
    return {
      loadConfig,
      isLock: false,
      list: [],
      popGameAdvShow: false,
      modifyData: {},
      isLoading: false,
      selectTab: 0,
      total: 0,
      condition: {
        game_type: "",
        status: "1",
        page: 1,
        limit: 15
      }
    };
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let rs = await this.$http.post("/game/adv/list", {
        ...this.condition
      });
      this.isLoading = false;
      if (rs.code == 0) {
        console.log(rs.data);
        this.list = rs.data.items;
        this.total = rs.data.total;
      }
    },
    async onCreate() {
      this.modifyData = {
        "game_type": 'sheep',
        'status': "1",
        "platform": 'adsgram'
      };
      this.popGameAdvShow = true;
    },
    async onModify(item) {
      this.modifyData = item;
      this.popGameAdvShow = true;
    },
    async onCopy(item) {
      this.modifyData = Object.assign({}, item);
      delete this.modifyData.id;
      this.popGameAdvShow = true;
    },
    cutStr(str) {
      if (str) return str.replace("T", " ").replace(".000Z", "");
    },
    onRefresh() {
      this.getData();
    },
    onPageChange(e) {
      this.condition.page = e;
      this.getData();
    },
    onPageSizeChange(e) {
      this.condition.limit = e;
      this.getData();
    }
  },
  mounted() {
    this.getData();
  }
};